import { yupResolver } from '@hookform/resolvers/yup'
import { Box } from '@mui/material'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'

import { acPostPasswordRecovery } from '../../store/actions'
import { PrimaryButton, Alert } from '../default'

import { FormInputText } from './formInputs'
import { FormValidationPasswordRecovery } from './formValidations'

const defaultValues = {
    email: ''
}

/**
 * Renders a form for password recovery. It uses the react-hook-form library for form validation and submission.
 * 
 * @author Maria Eduarda Franke
 * @returns {JSX.Element} The rendered password recovery form component.
 */
export const PasswordRecoveryForm = () => {

    const dispatch = useDispatch()

    const wasSuccessfulPasswordRecovery = useSelector(state => state.auth.wasSuccessfulPasswordRecovery)
    const isLoadingPasswordRecovery = useSelector(state => state.auth.isLoadingPasswordRecovery)
    const hasErrorPasswordRecovery = useSelector(state => state.auth.hasErrorPasswordRecovery)

    const { control, handleSubmit, reset, formState: { errors } } = useForm({
        defaultValues: defaultValues,
        resolver: yupResolver(FormValidationPasswordRecovery)
    })

    const onSubmit = handleSubmit((data) => {
        dispatch(acPostPasswordRecovery(data))
            .then(() => reset())
            .catch(error => console.error(error))
    })

    const getErrorMessage = () => {
        if (!hasErrorPasswordRecovery) return ''

        switch (hasErrorPasswordRecovery.description) {
            case 'INFRASTRUCTURE_CONNECTION_ERROR':
                return 'Serviço temporariamente indisponível. Tente novamente mais tarde!'
            default:
                return 'Erro ao recuperar senha!'
        }
    }

    return (
        <Box component='form' onSubmit={onSubmit} noValidate>
            {
                wasSuccessfulPasswordRecovery && (
                    <Alert
                        severity='success'
                        message='Caso exista uma conta LCD vinculada à este e-mail, a redefinição de senha terá sido enviado!'
                        sx={{ mb: 1 }}
                    />
                )
            }
            {
                hasErrorPasswordRecovery && (
                    <Alert
                        severity='error'
                        message={getErrorMessage()}
                        sx={{ mb: 1 }}
                    />
                )
            }
            <FormInputText
                name='email'
                label='E-mail'
                placeholder='Digite seu e-mail'
                control={control}
                errors={errors.email}
                fullWidth
                margin='normal'
                required
            />
            <PrimaryButton
                label='Solicitar Recuperação'
                loading={isLoadingPasswordRecovery}
                type='submit'
                fullWidth
                sx={{ mt: 2 }}
            />
        </Box>
    )

}